import { Component } from '../../scripts/component';

class ReleaseCountdown extends Component {
  constructor() {
    super();

    this.price = null;
    this.priceCurrency = null;
    this.imgUrl = null;
    this.productUrl = null;
    this.releaseDate = null;
    this.days = null;
    this.hours = null;
    this.minutes = null;
    this.seconds = null;
    this.formSubmitted = false;
  }

  connectedCallback() {
    super.connectedCallback();
    this.init();
    this.getData();
    this.startCounter();
    this.addEvents();

    // Skip countdown updates for "Expected Release" mode (no specific date)
    if (this.dataset.expectedRelease !== 'true') {
      this.updateCounterPDP();
    }

    if (this.dataset.releaseDateProductCardBadge) {
      this.classList.add('bg-badge-background', 'w-24', 'text-center');
      this.updateCounterProductCardBadge();
    }
  }

  startCounter() {
    this.releaseDate = this.dataset.releaseDate;
    if (!this.releaseDate) return;

    this.releaseDate = new Date(this.releaseDate * 1000);

    this.days = this.querySelector('[data-days]');
    this.hours = this.querySelector('[data-hours]');
    this.minutes = this.querySelector('[data-minutes]');
    this.seconds = this.querySelector('[data-seconds]');
  }

  updateCounterPDP() {
    if (!this.releaseDate) return;

    const now = new Date();
    const diff = this.releaseDate - now;

    // don't worry about it
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    this.days && (this.days.textContent = days);
    this.hours && (this.hours.textContent = hours);
    this.minutes && (this.minutes.textContent = minutes);
    this.seconds && (this.seconds.textContent = seconds);

    if (diff < 0) {
      this.days && (this.days.textContent = 0);
      this.hours && (this.hours.textContent = 0);
      this.minutes && (this.minutes.textContent = 0);
      this.seconds && (this.seconds.textContent = 0);
      if (!this.formSubmitted) {
        location.reload();
      }
    }

    setTimeout(() => this.updateCounterPDP(), 1000);
  }

  getData() {
    if (!window.shopifyProductData) return;

    this.price = shopifyProductData.price;
    this.priceCurrency = shopifyProductData.priceCurrency;
    this.imgUrl = shopifyProductData.imgUrl;
    this.productUrl = shopifyProductData.url;
  }

  addEvents() {
    this.drawerForm = this.querySelector('#release-countdown-form');

    if (this.drawerForm) {
      this.drawerForm.addEventListener('submit', (evt) => {
        evt.preventDefault();
        this.submitForm(evt);
      });
    }
  }

  async submitForm(evt) {
    if (!this.drawerForm) {
      console.warn('No drawer or drawer form found');
      return;
    }
    evt.preventDefault();

    this.formSubmitted = true;
    this.querySelector('.form-container')?.classList.add('hidden');
    this.querySelector('.form-success')?.classList.remove('hidden');

    // Dispatch event to notify other countdown components
    document.dispatchEvent(new CustomEvent('release-form-submitted'));

    try {
      const [first_name, last_name] = this.drawerForm.querySelector('input[name="name"]').value.split(' ');
      const now = new Date().toISOString();

      const newsletter = this.drawerForm.querySelector('input[name="newsletter"]')?.checked;
      const size = this.drawerForm.querySelector('select[name="size"]')?.value;
      const gender = this.drawerForm.querySelector('select[name="gender"]')?.value;
      const email = this.drawerForm.querySelector('input[name="email"]')?.value;

      const selectedSize = this.drawerForm.querySelector('select[name="size"]')?.selectedOptions?.[0] ?? null;
      const sku = selectedSize?.dataset?.sku;

      const imgUrl = this.imgUrl;
      const url = this.productUrl;

      if (!email) {
        console.warn('No email found');
        alert('There was an error with the email. Please try again.');
        return;
      }

      const options = {
        method: 'POST',
        headers: {
          accept: 'application/json',
          revision: '2024-02-15',
          'content-type': 'application/json',
        },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              properties: {
                newsletter: newsletter,
                size: size,
                sku: sku,
                imgUrl: imgUrl,
                gender: gender,
                url: url,
              },
              time: now,
              value: this.price,
              value_currency: this.priceCurrency,
              metric: { data: { type: 'metric', attributes: { name: 'Release reminder signup' } } },
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    first_name: first_name,
                    last_name: last_name,
                    properties: {},
                  },
                  meta: {
                    patch_properties: { append: {} },
                  },
                },
              },
            },
          },
        }),
      };

      await fetch('https://a.klaviyo.com/client/events/?company_id=XhVNP4', options);
      const listId = 'ScNcQQ';
      if (newsletter) await this.subscribeToList(listId, email);
    } catch (error) {
      console.error('❌ Release reminder submission error:', error);
    }
  }

  async subscribeToList(listId, email) {
    try {
      await fetch(`https://netlify.blacklemon.dk/.netlify/functions/subscribeProfileToList?listId=${listId}&email=${email}&store=rezet`);
    } catch (error) {
      console.error(error);
    }
  }

  init() {
    const button = this.querySelector('button');
    if (button)
      button.addEventListener('click', (evt) => {
        document.dispatchEvent(new CustomEvent('open-side-panel'));
        evt.preventDefault();
      });
    this.releaseDateProductCardBadge = this.dataset.releaseDateProductCardBadge;
  }

  updateCounterProductCardBadge() {
    if (!this.releaseDateProductCardBadge) return;

    const releaseDateProductCardBadge = new Date(this.releaseDateProductCardBadge * 1000);
    const diff = releaseDateProductCardBadge - new Date();

    if (diff < 0) {
      this.remove();
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    this.textContent = `${days.toString().padStart(2, '0')}:` + `${hours.toString().padStart(2, '0')}:` + `${minutes.toString().padStart(2, '0')}:` + `${seconds.toString().padStart(2, '0')}`;

    setTimeout(() => this.updateCounterProductCardBadge(), 1000);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }
}

if (!customElements.get('release-countdown')) {
  customElements.define('release-countdown', ReleaseCountdown);
}
